<ion-header mode="ios">
  <ion-toolbar color="secondary">
    <ion-title class="text-grey-ultra-dark">{{ 'pages.quotes.detail.title' | translate }}</ion-title>

    <ion-buttons slot="start" *ngIf="project.role === RoleEnum.GodamAdministrator">
      <ion-button [attr.aria-label]="'pages.quotes.modal.delete' | translate" (click)="delete()" data-cy="Delete quote">
        {{ 'pages.quotes.detail.delete' | translate }}
      </ion-button>
    </ion-buttons>

    <ion-buttons slot="end">
      <ion-button (click)="cancel()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <ui-current-cdc [project]="project"></ui-current-cdc>
</ion-header>

<ion-content class="ion-padding">
  <div class="tabbed-list-container flex flex-column h-full">
    <ion-segment #tabs class="tabs ion-padding-bottom" [value]="quoteDetailTab.DETAIL" mode="md" (ionChange)="onTabChange($event)">
      <ion-segment-button [value]="quoteDetailTab.DETAIL" data-cy="Detail tab">
        <ion-label class="fs-16 font-normal ion-text-capitalize">{{ 'pages.quotes.detail.tab.detail' | translate }}</ion-label>
      </ion-segment-button>
      <ion-segment-button [value]="quoteDetailTab.SUPPLY_ENTRIES" data-cy="Supply entries tab">
        <ion-label class="fs-16 font-normal ion-text-capitalize">{{ 'pages.quotes.detail.tab.supplyEntries' | translate }}</ion-label>
      </ion-segment-button>
    </ion-segment>
    <div [ngSwitch]="selectedTab" class="h-full">
      <ui-quote-detail
        *ngSwitchCase="quoteDetailTab.DETAIL"
        [identity]="identity"
        [detail]="quote"
        [showOverBudgetAmount]="showOverBudgetAmount"
      ></ui-quote-detail>
      <ui-quote-supply-entries
        *ngSwitchCase="quoteDetailTab.SUPPLY_ENTRIES"
        class="h-full"
        [detail]="quote"
        [project]="project"
      ></ui-quote-supply-entries>
    </div>
  </div>
</ion-content>
